import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getPushAlarm, setPushAlarm } from '../../../../features/mobile/settingSlice';
import HeadCont from '../../components/common/HeadCont';
import ToggleBtn from '../../components/common/Toggle';

const Push = () => {
    const { t } = useTranslation('settings');
    const dispatch = useDispatch()
    const { loginInfo } = useSelector((state) => state.commonApp)

    const notificationTypes = [
        { key: "all_notifications", value: "pushOnAll" },
        { key: "notice_notifications", value: "pushOnNotice" },
        { key: "meal_record_notifications", value: "pushOnEatRecord" },
        { key: "health_record_notifications", value: "pushOnDiary" },
        { key: "new_post_notifications", value: "pushOnNewPost" },
        { key: "comment_notifications", value: "pushOnNewReply" }
    ];
    const [toggle, setToggle] = useState({ pushOnAll: false, pushOnNotice: false, pushOnEatRecord: false, pushOnDiary: false, pushOnNewPost: false, pushOnNewReply: false })

    const onToggle = (paramValue) => {
        const par1 = { userId: loginInfo.userId, pushOnAll: !toggle.pushOnAll }
        const par2 = { userId: loginInfo.userId, pushOnNotice: !toggle.pushOnNotice }
        const par3 = { userId: loginInfo.userId, pushOnEatRecord: !toggle.pushOnEatRecord }
        const par4 = { userId: loginInfo.userId, pushOnDiary: !toggle.pushOnDiary }
        const par5 = { userId: loginInfo.userId, pushOnNewPost: !toggle.pushOnNewPost }
        const par6 = { userId: loginInfo.userId, pushOnNewReply: !toggle.pushOnNewReply }

        setToggle({ ...toggle, pushOnAll: !toggle.pushOnAll })

        if (paramValue === "pushOnAll") {
            if (toggle.pushOnAll) { //on -> off
                setToggle({
                    pushOnAll: false,
                    pushOnNotice: false,
                    pushOnEatRecord: false,
                    pushOnDiary: false,
                    pushOnNewPost: false,
                    pushOnNewReply: false
                })
            } else { //off -> on
                setToggle({
                    pushOnAll: true,
                    pushOnNotice: true,
                    pushOnEatRecord: true,
                    pushOnDiary: true,
                    pushOnNewPost: true,
                    pushOnNewReply: true
                })
            }
            dispatch(setPushAlarm(par1))
        } else if (paramValue === "pushOnNotice") {
            setToggle({ ...toggle, pushOnNotice: !toggle.pushOnNotice })
            dispatch(setPushAlarm(par2))
        } else if (paramValue === "pushOnEatRecord") {
            setToggle({ ...toggle, pushOnEatRecord: !toggle.pushOnEatRecord })
            dispatch(setPushAlarm(par3))
        } else if (paramValue === "pushOnDiary") {
            setToggle({ ...toggle, pushOnDiary: !toggle.pushOnDiary })
            dispatch(setPushAlarm(par4))
        } else if (paramValue === "pushOnNewPost") {
            setToggle({ ...toggle, pushOnNewPost: !toggle.pushOnNewPost })
            dispatch(setPushAlarm(par5))
        } else {
            setToggle({ ...toggle, pushOnNewReply: !toggle.pushOnNewReply })
            dispatch(setPushAlarm(par6))
        }
    }

    useEffect(() => {
        dispatch(getPushAlarm(loginInfo.userId))
            .unwrap()
            .then(res => {
                if (res.ok) {
                    setToggle(res)
                }
            })
            .catch(err => console.log(err))
    }, [dispatch, loginInfo.userId])

    return (
        <>
            <HeadCont rightIcon={'no icon'} transparent={'on'} title={t('notifications.title')} underline={true} />
            <section className='relative px-6 mb-6 mt-14'>
                <ul>
                    {notificationTypes.map((item, idx) => (
                        <li className='p-4' key={idx}>
                            <ToggleBtn
                                isOn={toggle[item.value]}
                                onToggle={() => onToggle(item.value)}
                                title={t(`notifications.${item.key}`)}
                                justifyB={true}
                            />
                        </li>
                    ))}
                </ul>
            </section>
        </>
    );
};

export default Push;